import type { ReactNode } from 'react';

export interface Column<T> {
  key: string;
  header: string;
  render: (row: T) => ReactNode;
  width?: string;
}

export interface TableProps<T> {
  columns: Column<T>[];
  rows: T[];
  rowKey: (row: T) => string | number;
  empty?: string;
  loading?: boolean;
  caption?: string;
}

export function Table<T>(props: TableProps<T>): React.JSX.Element {
  return (
    <div className="table-wrap">
      <table className="table">
        {props.caption && <caption className="visually-hidden">{props.caption}</caption>}
        <thead>
          <tr>
            {props.columns.map((c) => (
              <th key={c.key} style={c.width ? { width: c.width } : undefined}>
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.loading &&
            [0, 1, 2].map((i) => (
              <tr key={`sk-${i}`}>
                {props.columns.map((c) => (
                  <td key={c.key}>
                    <div className="skeleton" />
                  </td>
                ))}
              </tr>
            ))}
          {!props.loading && props.rows.length === 0 && (
            <tr>
              <td className="table__empty" colSpan={props.columns.length}>
                {props.empty ?? 'Nothing to show.'}
              </td>
            </tr>
          )}
          {!props.loading &&
            props.rows.map((row) => (
              <tr key={props.rowKey(row)}>
                {props.columns.map((c) => (
                  <td key={c.key}>{c.render(row)}</td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
